import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HotjarService {
  private hotjarLoaded = false;
  private siteId = '5291354'; // Replace with your actual Hotjar Site ID

  constructor() {
    this.loadHotjar();
  }

  loadHotjar() {
    if (this.hotjarLoaded) return;

    (window as any).hj =
      (window as any).hj ||
      function () {
        ((window as any).hj.q = (window as any).hj.q || []).push(arguments);
      };

    (window as any)._hjSettings = { hjid: this.siteId, hjsv: 6 };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://static.hotjar.com/c/hotjar-${this.siteId}.js?sv=6`;
    document.head.appendChild(script);

    this.hotjarLoaded = true;
    console.log('Hotjar tracking initialized.');
  }
}
